// story: HUD сюжетного режима — цель этапа со стрелкой и расстоянием,
// заголовок этапа по центру, шёпот картин внизу, полоса HP старухи, вспышка
// испуга и итоговый экран победы. Свой DOM и стили (вставляются один раз),
// чтобы не трогать разметку index.html.

import { t } from "../i18n";

const CSS = `
#story-hud { position: fixed; inset: 0; pointer-events: none; z-index: 6; font-family: var(--font-game, monospace); }
#story-hud.hidden { display: none; }
#story-goal { position: absolute; top: 12px; left: 12px;
  display: flex; flex-wrap: wrap; align-items: center; gap: 4px 10px; padding: 6px 12px; max-width: min(420px, 46vw);
  background: rgba(8, 6, 10, 0.62); border: 1px solid rgba(150, 120, 190, 0.45); border-radius: 8px;
  color: #e8dcf5; font-size: 20px; letter-spacing: 0.04em; text-shadow: 0 0 6px #000; }
#story-goal .stage { color: #b79be0; font-size: 15px; white-space: nowrap; flex-basis: 100%; }
#story-goal .title { overflow: hidden; text-overflow: ellipsis; }
#story-goal .nav { display: flex; align-items: center; gap: 6px; color: #f3d48a; font-size: 17px; white-space: nowrap; }
#story-goal .arrow { width: 18px; height: 18px; display: inline-block; transition: transform 0.08s linear; }
#story-goal .nav.hidden { display: none; }
#story-stats { position: absolute; top: 84px; left: 14px;
  color: #a99bb8; font-size: 15px; letter-spacing: 0.05em; text-shadow: 0 0 4px #000; white-space: nowrap; }
#story-banner { position: absolute; top: 24%; left: 50%; transform: translateX(-50%); text-align: center;
  color: #f0e6ff; font-size: 38px; letter-spacing: 0.08em; text-shadow: 0 0 18px #6b2fb3, 0 0 4px #000;
  opacity: 0; transition: opacity 0.6s ease; max-width: 92vw; }
#story-banner .sub { display: block; font-size: 18px; color: #cdbfe0; letter-spacing: 0.04em; margin-top: 8px; }
#story-banner.show { opacity: 1; }
#story-whisper { position: absolute; bottom: 21%; left: 50%; transform: translateX(-50%); text-align: center;
  max-width: min(760px, 90vw); color: #d9e8ff; font-size: 22px; font-style: italic; letter-spacing: 0.03em;
  text-shadow: 0 0 10px #2c5d9e, 0 0 3px #000; opacity: 0; transition: opacity 0.8s ease; }
#story-whisper.show { opacity: 0.95; }
#story-boss { position: absolute; top: 74px; left: 50%; transform: translateX(-50%); width: min(420px, 60vw);
  text-align: center; color: #e9c3b0; font-size: 16px; letter-spacing: 0.12em; text-shadow: 0 0 4px #000; }
#story-boss.hidden { display: none; }
#story-boss .bar { margin-top: 4px; height: 10px; background: rgba(0,0,0,0.6); border: 1px solid #6a2a20; border-radius: 3px; overflow: hidden; }
#story-boss .fill { height: 100%; width: 100%; background: linear-gradient(90deg, #6b0d0d, #c43a1c); transition: width 0.2s ease; }
/* Телефон: сверху полоса оружия и кнопка паузы, снизу здоровье/патроны и
   кнопки — блок цели уходит под полосу оружия, шёпот — выше середины. */
body.touch-ui #story-goal { top: 56px; left: max(12px, env(safe-area-inset-left)); font-size: 15px; padding: 4px 10px; max-width: 40vw; }
body.touch-ui #story-goal .stage { font-size: 12px; }
body.touch-ui #story-goal .nav { font-size: 14px; }
body.touch-ui #story-stats { top: 112px; left: max(14px, env(safe-area-inset-left)); font-size: 12px; }
body.touch-ui #story-whisper { bottom: auto; top: 34%; font-size: 15px; max-width: 70vw; }
body.touch-ui #story-banner { top: 18%; font-size: 26px; }
body.touch-ui #story-banner .sub { font-size: 14px; }
body.touch-ui #story-boss { top: 60px; left: auto; right: max(12px, env(safe-area-inset-right)); transform: none; width: 34vw; font-size: 13px; }
#story-scare { position: absolute; inset: 0; opacity: 0;
  background: radial-gradient(ellipse at center, rgba(200,230,255,0.10) 0%, rgba(150,200,255,0.35) 55%, rgba(10,20,40,0.85) 100%); }
#story-scare.on { animation: story-scare 0.9s ease-out; }
@keyframes story-scare { 0% { opacity: 1; filter: blur(2px); } 25% { opacity: 0.8; } 100% { opacity: 0; } }
#story-end { position: fixed; inset: 0; z-index: 19000; display: flex; flex-direction: column; align-items: center;
  justify-content: center; gap: 14px; padding: 20px; box-sizing: border-box; pointer-events: auto;
  background: radial-gradient(ellipse at center, rgba(40,10,60,0.86), rgba(0,0,0,0.93));
  font-family: var(--font-game, monospace); color: #eee; }
#story-end.hidden { display: none; }
#story-end h2 { margin: 0; font-size: 44px; letter-spacing: 0.1em; color: #f0e6ff; text-shadow: 0 0 22px #8a3ee0; text-align: center; }
#story-end .lead { font-size: 19px; color: #cdbfe0; max-width: 560px; text-align: center; }
#story-end table { border-collapse: collapse; font-size: 22px; }
#story-end td { padding: 4px 16px; }
#story-end td:first-child { color: #a99bb8; text-align: right; }
#story-end td:last-child { color: #f3d48a; }
#story-end .btns { display: flex; gap: 12px; margin-top: 6px; }
#story-end button { font-family: inherit; font-size: 20px; padding: 10px 22px; border-radius: 8px; cursor: pointer;
  border: 1px solid #7d5bb0; background: #2a1840; color: #f0e6ff; letter-spacing: 0.06em; }
#story-end button.primary { background: #5b2a9a; }
#story-end button:disabled { opacity: 0.5; cursor: default; }
@media (max-width: 700px) {
  #story-goal { font-size: 15px; top: 8px; left: 8px; max-width: 60vw; } #story-stats { top: 70px; left: 10px; font-size: 13px; }
  #story-banner { font-size: 26px; } #story-whisper { font-size: 17px; }
}
`;

const ARROW_SVG =
  '<svg viewBox="0 0 24 24" width="18" height="18"><path d="M12 2 L20 20 L12 15 L4 20 Z" fill="#f3d48a"/></svg>';

function fmtTime(sec: number): string {
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
}

export interface StoryEndStats {
  timeSec: number;
  kills: number;
  ghosts: number;
  deaths: number;
}

export class StoryHud {
  private root: HTMLDivElement;
  private goalStage: HTMLSpanElement;
  private goalTitle: HTMLSpanElement;
  private nav: HTMLSpanElement;
  private arrow: HTMLSpanElement;
  private dist: HTMLSpanElement;
  private stats: HTMLDivElement;
  private banner: HTMLDivElement;
  private whisper: HTMLDivElement;
  private boss: HTMLDivElement;
  private bossFill: HTMLDivElement;
  private scare: HTMLDivElement;
  private end: HTMLDivElement;
  private endStats: HTMLTableSectionElement;
  private endAgain: HTMLButtonElement;
  private endMenu: HTMLButtonElement;
  private bannerTimer = 0;
  private whisperTimer = 0;
  private lastStatsText = "";
  onAgain: (() => void) | null = null;
  onMenu: (() => void) | null = null;

  constructor() {
    if (!document.getElementById("story-hud-css")) {
      const st = document.createElement("style");
      st.id = "story-hud-css";
      st.textContent = CSS;
      document.head.appendChild(st);
    }
    const root = document.createElement("div");
    root.id = "story-hud";
    root.className = "hidden";
    root.dataset.i18nJs = "";
    root.setAttribute("aria-hidden", "true");
    root.innerHTML = `
      <div id="story-goal"><span class="stage"></span><span class="title"></span>
        <span class="nav"><span class="arrow">${ARROW_SVG}</span><span class="dist"></span></span></div>
      <div id="story-stats"></div>
      <div id="story-boss" class="hidden">${t("СТАРУХА")}<div class="bar"><div class="fill"></div></div></div>
      <div id="story-banner"></div>
      <div id="story-whisper" aria-live="polite"></div>
      <div id="story-scare"></div>`;
    document.body.appendChild(root);
    this.root = root;
    const q = <T extends Element>(sel: string): T => root.querySelector(sel) as T;
    this.goalStage = q("#story-goal .stage");
    this.goalTitle = q("#story-goal .title");
    this.nav = q("#story-goal .nav");
    this.arrow = q("#story-goal .arrow");
    this.dist = q("#story-goal .dist");
    this.stats = q("#story-stats");
    this.banner = q("#story-banner");
    this.whisper = q("#story-whisper");
    this.boss = q("#story-boss");
    this.bossFill = q("#story-boss .fill");
    this.scare = q("#story-scare");

    const end = document.createElement("div");
    end.id = "story-end";
    end.className = "hidden";
    end.dataset.i18nJs = "";
    end.innerHTML = `
      <h2>${t("КНИГА ЗАКЛИНАНИЙ")}</h2>
      <div class="lead">${t("Старуха мертва, книга у вас. Мертвецы сада легли обратно в землю, души дома свободны.")}</div>
      <table><tbody></tbody></table>
      <div class="btns"><button type="button" class="primary" data-act="again">${t("Ещё раз")}</button>
        <button type="button" data-act="menu">${t("В меню")}</button></div>`;
    document.body.appendChild(end);
    this.end = end;
    this.endStats = end.querySelector("tbody") as HTMLTableSectionElement;
    this.endAgain = end.querySelector('[data-act="again"]') as HTMLButtonElement;
    this.endMenu = end.querySelector('[data-act="menu"]') as HTMLButtonElement;
    // Кнопки запускают долгую загрузку — после нажатия обе недоступны
    // (повторный клик не стартует второй рестарт). Снова доступны при
    // следующем показе экрана.
    this.endAgain.addEventListener("click", () => {
      if (this.endAgain.disabled) return;
      this.endAgain.disabled = true;
      this.endMenu.disabled = true;
      this.onAgain?.();
    });
    this.endMenu.addEventListener("click", () => {
      if (this.endMenu.disabled) return;
      this.endAgain.disabled = true;
      this.endMenu.disabled = true;
      this.onMenu?.();
    });
  }

  setVisible(on: boolean): void {
    this.root.classList.toggle("hidden", !on);
  }

  setGoal(stage: number, total: number, title: string): void {
    this.goalStage.textContent = stage >= 1 && stage <= total ? t("ЭТАП {n}/{total}", { n: stage, total }) : "";
    if (this.goalTitle.textContent !== title) this.goalTitle.textContent = title;
  }

  /** Стрелка к цели: rel — угол цели относительно взгляда (рад, + влево). */
  setNav(visible: boolean, rel: number, distM: number, dz: number): void {
    this.nav.classList.toggle("hidden", !visible);
    if (!visible) return;
    this.arrow.style.transform = `rotate(${(-rel).toFixed(3)}rad)`;
    let txt = t("{n} м", { n: Math.round(distM) });
    if (dz > 2) txt += " ↑";
    else if (dz < -2) txt += " ↓";
    if (this.dist.textContent !== txt) this.dist.textContent = txt;
  }

  setStats(timeSec: number, kills: number, ghosts: number): void {
    const txt = `${fmtTime(timeSec)} · ${t("убито {n}", { n: kills })} · ${t("развеяно призраков {n}", { n: ghosts })}`;
    if (txt !== this.lastStatsText) {
      this.stats.textContent = txt;
      this.lastStatsText = txt;
    }
  }

  setBoss(visible: boolean, hpPct: number): void {
    this.boss.classList.toggle("hidden", !visible);
    if (visible) this.bossFill.style.width = `${Math.max(0, Math.min(100, hpPct))}%`;
  }

  showBanner(title: string, sub: string, ms = 4200): void {
    this.banner.innerHTML = "";
    this.banner.append(document.createTextNode(title));
    if (sub) {
      const s = document.createElement("span");
      s.className = "sub";
      s.textContent = sub;
      this.banner.append(s);
    }
    this.banner.classList.add("show");
    window.clearTimeout(this.bannerTimer);
    this.bannerTimer = window.setTimeout(() => this.banner.classList.remove("show"), ms);
  }

  showWhisper(text: string): void {
    this.whisper.textContent = t("«{text}»", { text });
    this.whisper.classList.add("show");
    window.clearTimeout(this.whisperTimer);
    const ms = Math.min(9000, 3200 + text.length * 55);
    this.whisperTimer = window.setTimeout(() => this.whisper.classList.remove("show"), ms);
  }

  flashScare(): void {
    this.scare.classList.remove("on");
    void this.scare.offsetWidth; // перезапуск анимации
    this.scare.classList.add("on");
  }

  showEnd(st: StoryEndStats): void {
    this.endStats.innerHTML = "";
    const row = (k: string, v: string): void => {
      const tr = document.createElement("tr");
      const a = document.createElement("td");
      const b = document.createElement("td");
      a.textContent = k;
      b.textContent = v;
      tr.append(a, b);
      this.endStats.append(tr);
    };
    row(t("Время"), fmtTime(st.timeSec));
    row(t("Убито нечисти"), String(st.kills));
    row(t("Развеяно призраков"), String(st.ghosts));
    row(t("Смертей"), String(st.deaths));
    this.endAgain.disabled = false;
    this.endMenu.disabled = false;
    this.end.classList.remove("hidden");
  }

  hideEnd(): void {
    this.end.classList.add("hidden");
  }

  endVisible(): boolean {
    return !this.end.classList.contains("hidden");
  }

  reset(): void {
    window.clearTimeout(this.bannerTimer);
    window.clearTimeout(this.whisperTimer);
    this.banner.classList.remove("show");
    this.whisper.classList.remove("show");
    this.boss.classList.add("hidden");
    this.hideEnd();
    this.setVisible(false);
    this.lastStatsText = "";
  }
}
